import { render, staticRenderFns } from "./SetupTabs.vue?vue&type=template&id=539d2446&scoped=true"
import script from "./SetupTabs.vue?vue&type=script&lang=js"
export * from "./SetupTabs.vue?vue&type=script&lang=js"
import style0 from "./SetupTabs.vue?vue&type=style&index=0&id=539d2446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d2446",
  null
  
)

export default component.exports